import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["row", "emptyTemplate"]
  static values = { 
    emptyMessage: String
  }

  connect() {
    this.checkEmpty()
    this.element.addEventListener("click", this.handleClick.bind(this))
  }

  handleClick(event) {
    // Find the clicked row
    const row = event.target.closest("[data-table-target='row'][data-url]")
    
    if (!row) return
    
    // Skip navigation if clicking on buttons or links
    if (event.target.closest("button, a")) {
      return
    }

    const url = row.dataset.url
    if (url) {
      window.location.href = url
    }
  }

  rowTargetConnected() {
    this.checkEmpty()
  }

  rowTargetDisconnected() {
    this.checkEmpty()
  }

  checkEmpty() {
    const hasRows = this.rowTargets.length > 0
    
    if (hasRows) {
      this.hideEmptyState()
    } else if (this.hasEmptyTemplateTarget) {
      this.showEmptyState()
    }
  }

  showEmptyState() {
    if (!this.emptyElement) {
      this.createEmptyState()
    }
    this.emptyElement.classList.remove("hidden")
  }

  hideEmptyState() {
    if (this.emptyElement) {
      this.emptyElement.classList.add("hidden")
    }
  }

  createEmptyState() {
    this.emptyElement = this.emptyTemplateTarget.content.cloneNode(true).firstElementChild
    this.element.appendChild(this.emptyElement)
  }
}